<script lang="ts">
    import {MouseEnterTipsViewUtil} from "../Information/MouseEnterTipsViewUtil";
    import {ValueUtil} from "../../../lib/Common/Value/ValueUtil";

    export let message;
    export let inversionColor = false;


    let setTimeoutId = null;
    const HoverRequireMilliSeconds = 250; // ホバーから表示まで必要な時間(ms)

    function onMouseEnter(event) {
        setTimeoutId = setTimeout(() => {
            setTimeoutId = null;
            MouseEnterTipsViewUtil.show(event, message);
        }, HoverRequireMilliSeconds);
    }

    function onMouseLeave(event) {
        if (setTimeoutId != null) {
            clearTimeout(setTimeoutId);
        }
    }


</script>

{#if !ValueUtil.isEmpty(message)}
    <div class="hover-tips-view"
         on:mouseenter={onMouseEnter}
         on:mouseleave={onMouseLeave}
         class:inversion-color={inversionColor}
    >
        <span>？</span>


    </div>
{/if}
<style lang="scss">
    .hover-tips-view {
        background-color: var(--text-color);
        color: var(--background-color);
        width: 1.5em;
        height: 1.5em;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: 1em;
        border-radius: 50%;

        user-select: none;
        cursor: help;

        font-size: 10px;
        opacity: 0.5;

        &:hover {
            opacity: 1;
        }

        > span {
            width: 1em;
            height: 1em;
        }

        &.inversion-color {
            color: var(--text-color);
            background-color: var(--background-color);
        }
    }
</style>